import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';
import { format } from 'one-util-date';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';

import {
    Skeleton,Disposition
} from 'one-model-local';


import {
resetAction
} from 'one-state-servicenow-verify/src/actions'

import {
    SETSELECTED,
    SETPATIENTSELECTED,
    SET,
    RESET
} from 'one-state-subject/src/types';


export const enum Types {
    GetVerifyCaller = 'verify-caller',
    PushtoCaller = 'one-state-verify-service/set',
    STORE_DISPOSITION_CODE = "store-disposition-code",
}


const pushToServiceCaller = (payload: any) => ({ type: Types.PushtoCaller, payload });
const pushToSkeleton = (payload: any) => setSkeletonAction(payload);
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

/**
 * This Fuction will fetch the data form Service Now for CallerDetails
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */

export const fetchServiceNowCallerEpic = (context: any) => (
    (action$: ActionsObservable<any>, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, log, agentId, alertnotification, settings: { compatible, epicendpoints: { servicenowcustomerdetails, apitoken },
        uisettings: {
            dashboardapiconfig: {
                servicenowcustomerdetails : servicenowcustomerdetailsApi
            }
        },
    } } = context;
        const { contact_center_type } = compatible;
        return action$.pipe(
            ofType(Types.GetVerifyCaller),
            mergeMap(action => {
                /**
                 * @param dataresponse contains the patient response
                 */
                const dataresponse: any = action.payload;
                log.debug("one-epic", "CustomerDetails request", dataresponse);
                const getRequest = (reqresponse: any) => {
                    let respreturn;
                    if (reqresponse) {
                        let headers = new Headers();
                        headers.append("Accept", "application/json");
                        headers.append("Authorization", "Basic " + apitoken?.token);
                        headers.append("Content-Type", "text/plain");
                        
                        const response = server.get({
                            path: servicenowcustomerdetails + "?sysparm_query=GOTO123TEXTQUERY321%3D" + reqresponse?.callerdata + "&sysparm_display_value=true&sysparm_exclude_reference_link=true&sysparm_fields=name,mobile_phone,phone,email,sys_id,street,city,state,country,zip,employee_number",
                            headers: headers
                        })
                            .then((resp: any) => resp)
                            .catch((responseerror: any) => {
                                log.error("one-epic", "patientEpic Error", responseerror);
                                // SEND to ALERT notificaiton/NOC servers for critical error on no active server
                                if (responseerror?.status === 0) {
                                    if (alertnotification?.isEnabled()) {
                                        var timestamp = new Date().toJSON();
                                        alertnotification.notify({
                                            "error_code": "930-31",
                                            "error_type": "SERVER_ERROR",
                                            "error_description": "Unable to reach active servers",
                                            "error_supertype": "SERVER_FAILS",
                                            "error_detail": "Unable to reach any of server for retring data ",
                                            "alert": "Yes",
                                            "timestamp": timestamp,
                                            "params": responseerror
                                        });
                                    }
                                }
                                let subjecterror: ErrorObject = {
                                    source: "SN-Callerdetails",
                                    type: "error",
                                    status: responseerror?.status,
                                    erroritems: responseerror?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return subjecterror;
                            })
                        respreturn = from(response);
                    } else {
                        respreturn = from([]);
                    }
                    log.debug("one-epic", "patientEpic response", respreturn);
                    return respreturn;
                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                if (!servicenowcustomerdetailsApi) return []
                return getRequest(dataresponse).
                    pipe(
                        map(response => TransformResponse(response, context))).
                    pipe(
                        flatMap((response: any) => {
                            const actions: any = [
                                pushToServiceCaller(response.servicecallerdata)
                            ];
                            //Making skeleton to false
                            let skeletonsource: Skeleton = {
                                customerdetails_skeleton: false
                            }
                            actions.push(pushToSkeleton(skeletonsource));
                            // check for error messages.
                            
                            if (response?.error) {
                                let disp: Disposition = { value: "1011" }
                                actions.push(addAction(response.error));
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    disp.meta00 = agentIdValue;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta01 = response?.error?.status;
                                disp.meta02 = dataresponse?.callerdata;
                                disp.meta03 = 'client';
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "195" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    disp.meta00 = agentIdValue;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta01 = dataresponse?.callerdata;
                                actions.push(pushToDisposition(disp));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);


export const clearSNCallerDetailsEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, servicenow-caller-reset-epic",
            "clear-servicenow-caller-reset-epic", {
        });
        return action$.pipe(
            ofType(SET, SETSELECTED, RESET, SETPATIENTSELECTED),
            map(action => resetAction())
        )

    }
);

